import { render } from "./ListaCorretores.vue?vue&type=template&id=d8116c5a"
import script from "./ListaCorretores.vue?vue&type=script&lang=js"
export * from "./ListaCorretores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__